<template>
  <div class="schedule-view-toggle">
    <el-tooltip placement="bottom">
      <template #content>
        <div>Calendar View</div>
      </template>
      <div
        :class="{ active: viewType === 'calendar' }"
        class="toggle-option calendar marker--schedule-view-toggle--calendar"
        @click="changeViewType('calendar')"
      >
        <i class="ddi ddi-calendar" />
      </div>
    </el-tooltip>
    <el-tooltip placement="bottom">
      <template #content>
        <div>List View</div>
      </template>
      <div
        :class="{ active: viewType === 'list' }"
        class="toggle-option listing marker--schedule-view-toggle--listing"
        @click="changeViewType('list')"
      >
        <i class="ddi ddi-list" />
      </div>
    </el-tooltip>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ScheduleViewToggle',

  props: {
    viewType: {
      type: String,
      default: 'calendar',
    },
  },

  emits: ['update:viewType'],

  methods: {
    changeViewType(type: string) {
      if (type !== this.viewType) {
        this.$emit('update:viewType', type)
      }
    },
  },
})
</script>

<style lang="scss">
.schedule-view-toggle {
  display: flex;
  color: var(--color-text-third);
  cursor: pointer;
  width: 72px;
  height: 32px;

  .toggle-option {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    font-size: 12px;
    border-style: solid;
    border-color: var(--color-text-third);

    &.calendar {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      border-width: 1px;
    }

    &.listing {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-width: 1px 1px 1px 0;
    }
  }

  .active {
    color: $color--white;
    cursor: default;
    background: $color--gray-60;
  }
}
</style>
